import Http from '@/libs/http.js';

/**
 * 获取区划企业列表
 * @returns {Promise}
 */
export const getStageItemLicenceListByProjectNo = (data) => {
    return new Promise((resolve, reject) => {
        const instance=new Http(window.host2)
        instance.post('/getStageItemLicenceListByProjectNo',data)
        .then(res => {
            resolve(res);
        })
        .catch(err => {
            reject(err);
        });
    });
};